import { CardSize } from '../../../../utils/type'
import { CSSProperties, ReactNode, useMemo } from 'react'
import { useRequest } from 'ahooks'
import styled, { css } from 'styled-components'
import { commonStyles } from '../../../../utils/commonStyles'
import { sizeMap } from './common'

async function fetchText(uri: string) {
  const res = await fetch(uri)
  return res.text()
}

export function CardText(props: {
  content_uri: string
  size: CardSize
  className?: string
  style?: CSSProperties
  children?: ReactNode
}) {
  const { data, loading } = useRequest(() => fetchText(props.content_uri), {
    refreshDeps: [props.content_uri],
    cacheKey: props.content_uri,
  })
  const text = useMemo(() => {
    const _data = data || ''
    try {
      const json = JSON.parse(_data)
      return JSON.stringify(json, null, 2)
    } catch (e) {}
    return _data
  }, [data])
  //计算行数
  const line = useMemo(() => text.split('\n').length, [text])
  return (
    <TextCardWrapper className={props.className} style={props.style} isLoading={loading} size={props.size} line={line}>
      <p>{text}</p>
      {props.children}
    </TextCardWrapper>
  )
}

const fontMap: {
  [key in CardSize]: {
    size: number
    height: number
  }
} = {
  [CardSize.Small]: {
    size: 30,
    height: 44,
  },
  [CardSize.Medium]: {
    size: 16,
    height: 25,
  },
  [CardSize.Large]: {
    size: 30,
    height: 44,
  },
}

const TextCardWrapper = styled.div<{ isLoading?: boolean; size: CardSize; line: number }>`
  ${(props) =>
    props.size === CardSize.Medium
      ? css`
          width: 100%;
          aspect-ratio: ${sizeMap[props.size].width} / ${sizeMap[props.size].height};
        `
      : css`
          height: ${sizeMap[props.size].height}px;
          width: ${sizeMap[props.size].width}px;
        `}

  position: relative;
  overflow: ${(props) => (props.size === CardSize.Small ? 'hidden' : 'auto')};
  ${(props) => (props.isLoading ? commonStyles.skeleton : '')};
  ${commonStyles.flexCenter};
  display: ${(props) => (props.line > 40 ? 'block' : 'flex')};

  background-color: #231f20;
  ${(props) =>
    props.size === CardSize.Large
      ? css`
          font-size: max(8px, min(calc(500px / ${props.line} / 1.4), 30px));
        `
      : css`
          font-size: ${fontMap[props.size].size}px;
        `}
  color: #fff;
  white-space: pre;
  line-height: 1.4em;
  p {
    width: ${(props) => (props.size === CardSize.Small ? '500px' : '100%')};
    //height: ${(props) => (props.size === CardSize.Small ? '500px' : '100%')};
    transform: scale(${(props) => (props.size === CardSize.Small ? 0.06 : 1)});
    transform-origin: center;
    display: ${(props) => (props.line > 40 ? 'block' : 'flex')};
    justify-content: center;
    align-items: center;
  }
`
